import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cached = null;
let inflight = null;

export function invalidateCategoryImagesCache() {
  cached = null;
  inflight = null;
}

async function fetchCategoryImages() {
  if (cached) return cached;
  if (!inflight) {
    inflight = axios
      .get(`${API}/categories/images`)
      .then((r) => {
        cached = r.data || {};
        return cached;
      })
      .catch(() => {
        cached = {};
        return cached;
      });
  }
  return inflight;
}

/**
 * Returns { [categoryId]: url } for admin-uploaded category images.
 * Falls back to /brand/categories/{id}.png when no override exists.
 */
export function useCategoryImages() {
  const [images, setImages] = useState(() => cached || {});
  useEffect(() => {
    let cancelled = false;
    fetchCategoryImages().then((data) => {
      if (!cancelled) setImages(data);
    });
    return () => { cancelled = true; };
  }, []);
  return images;
}

/**
 * Helper to resolve a category image URL. Admin override takes precedence.
 * Backend URLs starting with /api/... are prefixed with REACT_APP_BACKEND_URL.
 */
export function resolveCategoryImage(categoryId, overrides) {
  const override = overrides && overrides[categoryId];
  if (override) {
    if (override.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${override}`;
    return override;
  }
  return `/brand/categories/${categoryId}.png`;
}
